import { Fingerprint, Download, PackageCheck, BadgeEuro } from "lucide-react";
import { Reveal } from "@/lib/motion";

const BENEFITS = [
  {
    icon: Fingerprint,
    title: "One tap",
    text: "Customers reach your Google review page with a simple tap.",
  },
  {
    icon: Download,
    title: "No app",
    text: "Customers don't need to download anything.",
  },
  {
    icon: PackageCheck,
    title: "Ready to use",
    text: "Your stand arrives configured for your business.",
  },
  {
    icon: BadgeEuro,
    title: "No subscription",
    text: "One purchase. No monthly software fee.",
  },
];

export const Benefits = () => (
  <section
    id="benefits"
    className="scroll-mt-24 bg-sand py-24 md:py-32"
    data-testid="benefits-section"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <p className="text-overline">Benefits</p>
        <h2 className="mt-4 max-w-2xl font-display text-4xl font-medium tracking-tight text-ink sm:text-5xl">
          More opportunities for reviews. Less friction.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.1}>
            <div className="group h-full rounded-3xl border border-black/5 bg-white p-8 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-transform duration-300 hover:-translate-y-1">
              <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-panel text-ink transition-colors duration-300 group-hover:bg-ink group-hover:text-white">
                <b.icon className="h-5 w-5" strokeWidth={1.6} />
              </span>
              <h3 className="mt-7 font-display text-xl font-medium tracking-tight text-ink">
                {b.title}
              </h3>
              <p className="mt-2.5 text-sm leading-relaxed text-graphite">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
